import { render, staticRenderFns } from "./BookingSuccessPage.vue?vue&type=template&id=5553f5b9"
import script from "./BookingSuccessPage.vue?vue&type=script&lang=js"
export * from "./BookingSuccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports